'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @primitive Checkbox
 * ROLE: checkbox | ARIA: aria-checked (true/false/mixed for indeterminate)
 * KEYBOARD: Space toggles; Tab focuses
 * FOCUS: single focus stop
 * LIVE-REGION: none (aria-checked change announced by AT)
 * PRM: check animation instant
 * FORCED-COLORS: border = ButtonText; checked background = Highlight
 * RTL: label on logical end; checkmark direction-agnostic
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/patterns/checkbox/
 * SUBSTRATE: @radix-ui/react-checkbox
 */
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import styles from './Checkbox.module.css';
export function Checkbox({ checked, onCheckedChange, disabled = false, id, label, ...ariaProps }) {
    return (_jsxs("label", { className: styles.wrapper, children: [_jsx(RadixCheckbox.Root, { checked: checked, onCheckedChange: onCheckedChange, disabled: disabled, id: id, className: styles.root, ...ariaProps, children: _jsx(RadixCheckbox.Indicator, { className: styles.indicator, children: checked === 'indeterminate' ? (_jsx("svg", { width: "10", height: "2", viewBox: "0 0 10 2", "aria-hidden": "true", children: _jsx("rect", { width: "10", height: "2", rx: "1", fill: "currentColor" }) })) : (_jsx("svg", { width: "10", height: "8", viewBox: "0 0 10 8", "aria-hidden": "true", children: _jsx("path", { d: "M1 4l2.5 2.5L9 1", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }) })) }) }), label && _jsx("span", { className: styles.label, children: label })] }));
}
//# sourceMappingURL=Checkbox.js.map